/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateDocumentNameForLeadRequest
 */
export interface UpdateDocumentNameForLeadRequest {
    /**
     * New user-facing document name. Trimmed, then capped at 255 characters; the canonical `name` is left untouched.
     */
    display_name: string;
}

/**
 * Check if a given object implements the UpdateDocumentNameForLeadRequest interface.
 */
export function instanceOfUpdateDocumentNameForLeadRequest(value: object): value is UpdateDocumentNameForLeadRequest {
    if (!('display_name' in value) || value['display_name'] === undefined) return false;
    return true;
}

export function UpdateDocumentNameForLeadRequestFromJSON(json: any): UpdateDocumentNameForLeadRequest {
    return UpdateDocumentNameForLeadRequestFromJSONTyped(json, false);
}

export function UpdateDocumentNameForLeadRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateDocumentNameForLeadRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'display_name': json['display_name'],
    };
}

export function UpdateDocumentNameForLeadRequestToJSON(json: any): UpdateDocumentNameForLeadRequest {
    return UpdateDocumentNameForLeadRequestToJSONTyped(json, false);
}

export function UpdateDocumentNameForLeadRequestToJSONTyped(value?: UpdateDocumentNameForLeadRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'display_name': value['display_name'],
    };
}

